var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8126 18.6875C17.3876 18.6875 20.3126 15.7625 20.3126 12.1875C20.3126 8.6125 17.3876 5.6875 13.8126 5.6875C10.2376 5.6875 7.31258 8.6125 7.31258 12.1875C7.31258 15.7625 10.2376 18.6875 13.8126 18.6875ZM21.1251 17.225C23.8876 19.5 27.9501 19.0125 30.2251 16.25C32.5001 13.4875 32.0126 9.425 29.2501 7.15C28.1126 6.175 26.6501 5.6875 25.1876 5.6875C23.7251 5.6875 22.2626 6.175 21.1251 7.15C23.8876 9.425 24.3751 13.325 22.1001 16.25C21.9376 16.575 21.4501 16.9 21.1251 17.225ZM37.2126 31.525C36.2376 25.5125 31.2001 21.125 25.1876 21.125C23.7251 21.125 22.4251 21.2875 21.1251 21.775C25.3501 23.2375 28.4376 26.975 29.0876 31.3625C29.2501 32.175 28.6001 33.15 27.6251 33.15H27.4626H35.5876C36.5626 33.15 37.2126 32.5 37.2126 31.525ZM13.8126 21.125C7.80008 21.125 2.60008 25.5125 1.78758 31.525C1.62508 32.3375 2.27508 33.3125 3.25008 33.3125H3.41258H24.2126C25.1876 33.3125 25.8376 32.6625 25.8376 31.6875V31.525C25.0251 25.5125 19.8251 21.125 13.8126 21.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceIcon);
export default __webpack_public_path__ + "static/media/AttendanceIcon.4f48f7d8aeee4909c3f1301ee3b0e7de.svg";
export { ForwardRef as ReactComponent };